import { Button, Grid, MenuItem, TextField } from '@material-ui/core'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { mdiFilterMultiple } from '@mdi/js'
import Icon from '@mdi/react'

import colors from '../../../assets/colors'
import BaseFilter from '../../../components/hooks/BaseFilter'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import { fetchAddonCharges } from '../SubscriptionActions'

const STATUS_OPTIONS = [
  { value: 10, label: 'Aguardando pagamento' },
  { value: 20, label: 'Pago' },
  { value: 30, label: 'Falhou' },
]

const SOURCE_OPTIONS = [
  { value: 'contract', label: 'Contratação' },
  { value: 'quantity_increase', label: 'Aumento de quantidade' },
]

const AddonChargesFilter = () => {
  const styles = filterStylesComponents()
  const dispatch = useDispatch()

  const [form, setForm] = useState({
    status: '',
    source: '',
    date_start: null,
    date_end: null,
  })

  const handleChange = e => {
    const { name, value } = e.target
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = () => {
    dispatch(fetchAddonCharges(form))
  }

  return (
    <BaseFilter>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item md={3} sm={5} lg={3}>
            <TextField
              select
              name="status"
              label="Status"
              fullWidth
              value={form.status}
              onChange={handleChange}
            >
              <MenuItem value="">Selecione...</MenuItem>
              {STATUS_OPTIONS.map(option => (
                <MenuItem value={option.value} key={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item md={3} sm={5}>
            <TextField
              select
              name="source"
              label="Origem"
              fullWidth
              value={form.source}
              onChange={handleChange}
            >
              <MenuItem value="">Selecione...</MenuItem>
              {SOURCE_OPTIONS.map(option => (
                <MenuItem value={option.value} key={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item md={3} sm={5}>
            <KeyboardDatePicker
              clearable
              value={form.date_start}
              label="Data Inicial"
              fullWidth
              clearLabel="Limpar"
              autoOk
              inputVariant="standard"
              onChange={date =>
                setForm(prev => ({ ...prev, date_start: date }))
              }
              format="dd/MM/yyyy"
            />
          </Grid>

          <Grid item md={3} sm={5}>
            <KeyboardDatePicker
              clearable
              value={form.date_end}
              label="Data Final"
              fullWidth
              clearLabel="Limpar"
              autoOk
              inputVariant="standard"
              onChange={date => setForm(prev => ({ ...prev, date_end: date }))}
              format="dd/MM/yyyy"
            />
          </Grid>

          <Grid item xs container alignItems="center">
            <Button className={styles.btnMoreFilters} onClick={handleSubmit}>
              <Icon
                path={mdiFilterMultiple}
                size={1}
                color={colors.secondary}
              />
              {` Filtrar`}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </BaseFilter>
  )
}

export default AddonChargesFilter
